export default "__VITE_ASSET__CJtIdUEl__"